import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../slices/authSlice';
import { getStoredToken } from '../utils/authToken';
import { VideoProvider } from '../landing/context/VideoContext';
import LandingLayout from '../landing/layout/LandingLayout';
import FAQPage from '../landing/components/FAQPage';

const FAQPageWrapper = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.token);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const storedToken = getStoredToken();
        setIsAuthenticated(Boolean(token || storedToken));
    }, [token]);

    const handleRegister = () => navigate('/register');
    const handleLogin = () => navigate('/login');
    const handleDashboard = () => navigate('/dashboard');
    const handleLogout = () => {
        dispatch(logout());
        setIsAuthenticated(false);
        navigate('/');
    };

    return (
        <VideoProvider>
            <LandingLayout
                isAuthenticated={isAuthenticated}
                onLogin={handleLogin}
                onLogout={handleLogout}
                onRegister={handleRegister}
                onDashboard={handleDashboard}
            >
                <FAQPage />
            </LandingLayout>
        </VideoProvider>
    );
};

export default FAQPageWrapper;
